export default "__VITE_ASSET__D_zmWC3s__"